import React from "react";
import {Tooltip} from "@mui/material";

const SmallThemeColor = ({color, array}) => {

    return (
        <>
            <Tooltip followCursor title={`${color.colorName}: ${color?.value}`}>
                <div
                    key={color}
                    className={'other-colors'}
                    style={{
                        '--other-color': color?.value,
                        '--other-color-length': array?.length,
                    }}
                />
            </Tooltip>
        </>
    );
}

export default SmallThemeColor;
